<report-filter 
  showCostCenters='true'
  showFacilities='true'
  showShiftBlocks='true'
  showPeriodEndDateSelection='true'
  showPeriodEndDateSelection='true'
  defaultPayPeriodsBack=1
  showViews='true'
  [(views)]="views"
  [defaultView] = "defaultView"
  reportType='ancillary'
  ancillaryType='total'
  [(defaultFilter)]="filters"
  (filterUpdated)="filterUpdated($event)">
</report-filter>

<smt-totaluostrendsreport
  [filtersUpdated]='filterEventsSubject.asObservable()' 
  (dataUpdated)='dataUpdated($event)'
  [(reportFilters)]='filters'>
</smt-totaluostrendsreport>

<report-export-button
[reportFilters]="filters"
[exportUrl]="'TotalUosReport/GetTotalUOSTrendsReportExportData'"
[fileName]="'TotalUOS_Trends_Report'"
[filtersUpdated]='filterEventsSubject.asObservable()'>
</report-export-button>

<table class='condensed' role='list'>
    <thead>
      <th><!-- empty row for the series names --></th>
      <th *ngFor='let item of data.xAxis'><div>{{item}}&nbsp;&nbsp;</div></th>
    </thead>
    <tr *ngFor='let dataSet of chartData'>
      <td>{{dataSet.name}}</td> 
      <td *ngFor='let item of dataSet.data'>{{formatValue(item)}}</td>
    </tr>
  </table>